<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<!--<button #focusableEleTop class="focusable-element"></button>-->
<div class="container" (keydown)="onKeyDown($event)">
    <div class="row">
        <div class="col-16">
            <h1 class="medium" tabindex="1000">
                Tell us about the applicant (Individual Enrollment)
            </h1>
            <br />
        </div>
    </div>
    <div class="row" *ngIf="hasError" aria-live="polite" tabindex="0" role="alert" #focusableEleTop>
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul role="list">
                    <li *ngFor="let error of ErrorMessages" aria-atomic="true" role="listitem">
                        <a (click)="goToControl(error)">{{error}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="IsErrorMesssage" aria-live="polite" tabindex="0" role="alert">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul role="list">
                    <li *ngFor="let error of errorMessage" aria-atomic="true" role="listitem">{{error}}</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Agent ID for this enrollment:'" [text]="agentUserName"
                    (onValueChange)="dataEntryStep1.AgentName = $event" [validators]="[notBlankValidator]"
                    [disabled]="isValidAgent" [for]="AgentID">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-8" *ngIf="false">
            <div class="input-wrapper">
                <button class="button primary" (click)="onContinue()">Change</button>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16" id="TextPLANTYPE"
            [ngClass]="{'highlight-error': (linktoErrorControl.isPLANTYPError ===true) }">
            <ValidatedRadioButtonGroup [label]="'Desired Plan'" [options]="optionrbPlan"
                [selectedValue]="enrollmentViewModel.PLANTYPE" (onValueChange)="onPlanChange($event)"
                [radioGroupName]="'Plan'">
            </ValidatedRadioButtonGroup>
        </div>
    </div>

    <div class="row">
        <div class="col-10" id="TXTAPPDT" style="margin-top: 6px;"
            [ngClass]="{'highlight-error':(linktoErrorControl.isAPPDTError ===true) }">
            <div class="input-wrapper">
                <!-- <label>Application Receipt Date (Date of receipt of completed application by Plan):</label>-->
                <JQDatePicker for="APPDT" [label]="'Application Receipt Date (Date of receipt of completed application by Plan):'"
                              [selectedDate]="enrollmentViewModel.APPDT" (elementClicked)="onAppdatechange($event)" id="APPDT">

                </JQDatePicker>
                <!--(elementClicked)="enrollmentViewModel.APPDT = $event">(elementClicked)="onAppdatechange($event)">-->
            </div>
        </div>
        <div class="col-6" id="txtEFFDT" style="margin-left: 6px;margin-top: 6px;"
            [ngClass]="{'highlight-error': (linktoErrorControl.isEFFDTError ===true) }">
            <div class="input-wrapper">
                <!--<label>Effective Date:</label>-->
                <JQDatePicker for="EFFDT" [label]="'Effective Date:'" [selectedDate]="enrollmentViewModel.EFFDT"
                              (elementClicked)="enrollmentViewModel.EFFDT = $event" id="EFFDT">
                </JQDatePicker>

            </div>
        </div>
    </div>

    <div class="row" *ngIf="false">
        <div class="col-16">
            <div class="input-wrapper">
                <ValidatedCheckbox class="centered-checkbox" [id]="'po-box'"
                    [label]="'I suggested or recommended a plan'" [checked]="enrollmentViewModel.POBOX"
                    (onValueChange)="enrollmentViewModel.POBOX= $event">
                </ValidatedCheckbox>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-6" id="TxtAPPLN" style="margin-top: 6px;"
            [ngClass]="{'highlight-error':linktoErrorControl.isAPPLNrror===true }">
            <div class="input-wrapper">
                <ValidatedTextField label="Last Name" [text]="enrollmentViewModel.APPLN"
                    (onValueChange)="enrollmentViewModel.APPLN = $event" [validators]="[LettersonlyAllowedFieldValidator,notBlankValidator]">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-6" id="TxtAPPFN" style="margin-left: 6px; margin-top: 6px;"
            [ngClass]="{'highlight-error':linktoErrorControl.isAPPFNError===true }">
            <div class="input-wrapper" >
                <ValidatedTextField label="First Name" [text]="enrollmentViewModel.APPFN"
                    (onValueChange)="enrollmentViewModel.APPFN = $event"   [validators]="[LettersonlyAllowedFieldValidator,notBlankValidator]">>
                </ValidatedTextField>
                
            </div>
           
        </div>
        <div class="col-4" id="TxtAPPMI" style="margin-left: 6px;margin-top: 6px;"
            [ngClass]="{'highlight-error':linktoErrorControl.isAAPPMIrror===true}">
            <div class="input-wrapper">
                <ValidatedTextField label="MI (optional)" [text]="enrollmentViewModel.APPMI" [maxlength]="1"
                    (onValueChange)="enrollmentViewModel.APPMI = $event" [validators]="[LettersonlyAllowedFieldValidator]">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-4" style="margin-top: 6px;">
            <div class="input-wrapper">
                <ValidatedDropDown class="wide" [selectedValue]="enrollmentViewModel.TITLE" [label]="'Title (optional)'"
                    (onValueChange)="enrollmentViewModel.TITLE = $event" [options]="titleOptions">
                </ValidatedDropDown>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-6" id="txtAPPDOB" style="margin-top: 6px;"
            [ngClass]="{'highlight-error': (linktoErrorControl.isDOBError ===true) }">
            <div class="input-wrapper">
                <ValidatedDateTextField label="Date of Birth" id="DOB" [date]="enrollmentViewModel.APPDOB"
                    (onDateChange)="enrollmentViewModel.APPDOB = $event"
                    [validators]="[validatedDate]">
                </ValidatedDateTextField>
            </div>
        </div>
        <div class="col-4" id="TxtAPPGEN" style="margin-top: 6px;margin-left: 6px;"
            [ngClass]="{'highlight-error': (linktoErrorControl.isSexError ===true) }">
            <ValidatedRadioButtonGroup label="Sex" [options]="genderOptions"
                [selectedValue]="enrollmentViewModel.APPGEN" [radioGroupName]="'genderOptions'"
                (onValueChange)="enrollmentViewModel.APPGEN = $event">
            </ValidatedRadioButtonGroup>
        </div>
        <div class="col-8" id="txtAPPPHONE" style="margin-top: 6px;margin-left: 6px;"
            [ngClass]="{'highlight-error': (linktoErrorControl.isAPPPHONEError ===true) }">
            <div class="input-wrapper">
                <MaskedValidatedTextField class="field" [label]="'Phone Number (optional)'" id="authrep-phone"
                [validators]="[phoneValidFieldValidator]"
                    [text]="enrollmentViewModel.APPPHONE" (onValueChange)="enrollmentViewModel.APPPHONE = $event"
                    [maxlength]="10" [inputMask]="phoneNumberInputMask">
                </MaskedValidatedTextField>
            </div>
        </div>
    </div>
    <fieldset>
        <legend> Permanent Address:</legend>
        <div class="row">
            <div class="col-24" *ngIf="visibleFrom2026">
                <div class="bottom-20">
                    <ValidatedCheckbox [id]="'poBox-Check'"
                        [label]="'Check if enrollee is currently experiencing homelessness'" [checked]="isPOBox"
                        (onValueChange)="poBoxChecked($event)">
                    </ValidatedCheckbox>
                </div>
            </div>
            <div class="col-8" id="TxtAPPADD1"
                [ngClass]="{'highlight-error':(linktoErrorControl.isAPPADD1rror ===true) }">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Permanent Street Address Line 1 (PO Box is not allowed)'"
                        [text]="enrollmentViewModel.APPADD1" [validators]="[accountNameInvalidValidator,notBlankValidator]" (blur)="onBlur()"
                        (onValueChange)="enrollmentViewModel.APPADD1 = $event" maxlength="40">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Permanent Street Address Line 2 (optional)'"
                        [text]="enrollmentViewModel.APPADD2" (blur)="onBlur()"
                        [validators]="[accountNameInvalidValidator]"
                        (onValueChange)="enrollmentViewModel.APPADD2= $event" maxlength="40">
                    </ValidatedTextField>
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col-8" id="txtAPPCITY" style="margin-top: 6px;"
                [ngClass]="{'highlight-error':(linktoErrorControl.isAPPCITYrror ===true) }">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'City'" [text]="enrollmentViewModel.APPCITY" [validators]="[LettersonlyAllowedFieldValidator,notBlankValidator]"
                        (blur)="onBlur()" (onValueChange)="enrollmentViewModel.APPCITY= $event" maxlength="40">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-5" id="txtAPPST" style="margin-top: 6px;margin-left: 6px;"
                [ngClass]="{'highlight-error': (linktoErrorControl.isAPPSTrror ===true) }">
                <div class="input-wrapper">
                    <ValidatedDropDown class="wide" [selectedValue]="enrollmentViewModel.APPST" [label]="'State'"
                        [disabled]="disabledstate" (onValueChange)="SelectState($event)" [options]="states"
                        (blur)="onBlur()">
                    </ValidatedDropDown>
                </div>
            </div>
            <div class="col-3" id="txtZip" style="margin-top: 6px;"
                [ngClass]="{'highlight-error': (linktoErrorControl.isZipERMError ===true) }">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Zip'" [text]="enrollmentViewModel.APPZIP"
                        [validators]="[validateZip,notBlankValidator]" (blur)="onBlur()"
                        (onValueChange)="enrollmentViewModel.APPZIP = $event" maxlength="5">
                    </ValidatedTextField>
                </div>
            </div>

        </div>
    </fieldset>

    <div class="row">
        <div class="col-24">

            <div class="bottom-20">
                <ValidatedCheckbox [id]="'same-as-business-address'"
                    [label]="'Mailing Address (only if Mailing Address is same as Permanent Address):'"
                    [checked]="enrollmentViewModel.ISSAMEADDRESS"
                    (onValueChange)="clickOnSameAsBusinessAddress($event)">
                </ValidatedCheckbox>
            </div>
        </div>
    </div>
    <div>
        <div *ngIf="IsSameAddress">
            <fieldset>
                <legend>Mailing Address</legend>
                <div class="row">
                    <div class="col-8" id="txtMAILADD1"
                        [ngClass]="{'highlight-error': (linktoErrorControl.isMAILADD1Error ===true) }">
                        <div class="input-wrapper">
                            <ValidatedTextField [label]="'Street Address Line 1'" [text]="enrollmentViewModel.MAILADD1"
                               (blur)="onBlur()" [disabled]="disabled"
                                [validators]="[accountNameInvalidValidator,notBlankValidator]"
                                (onValueChange)="enrollmentViewModel.MAILADD1= $event" maxlength="40">
                            </ValidatedTextField>
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="input-wrapper" aria-invalid="true">
                            <ValidatedTextField [label]="'Street Address Line 2 (optional)'"
                                [text]="enrollmentViewModel.MAILADD2" (blur)="onBlur()" [disabled]="disabled"
                                [validators]="[accountNameInvalidValidator]"
                                (onValueChange)="enrollmentViewModel.MAILADD2= $event" maxlength="40">
                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8" id="txtMAILCITY" style="margin-top: 6px;"
                        [ngClass]="{'highlight-error': (linktoErrorControl.isMAILCITYrror ===true) }">
                        <div class="input-wrapper">
                            <ValidatedTextField [label]="'City'" [text]="enrollmentViewModel.MAILCITY" [validators]="[LettersonlyAllowedFieldValidator,notBlankValidator]"
                                (blur)="onBlur()" [disabled]="disabled"
                                (onValueChange)="enrollmentViewModel.MAILCITY = $event" maxlength="40">
                            </ValidatedTextField>
                        </div>
                    </div>
                    <div class="col-5" id="txtMAILST" style="margin-top: 6px;margin-left: 6px;"
                        [ngClass]="{'highlight-error': (linktoErrorControl.isMAILSTrror ===true) }">
                        <div class="input-wrapper">
                            <ValidatedDropDown class="wide" [selectedValue]="enrollmentViewModel.MAILST"
                                [label]="'State'" [disabled]="disabled"
                                (onValueChange)="enrollmentViewModel.MAILST = $event" [options]="mailingstates"
                                (blur)="onBlur()">
                            </ValidatedDropDown>
                        </div>
                    </div>
                    <div class="col-3" id="txtMAILZIP" style="margin-top: 6px;margin-left: 6px;"
                        [ngClass]="{'highlight-error': (linktoErrorControl.isMAILZIPrror ===true) }">
                        <div class="input-wrapper">
                            <ValidatedTextField [label]="'Zip'" [text]="enrollmentViewModel.MAILZIP"
                                [validators]="[validateZip,notBlankValidator]" (blur)="onBlur()" [disabled]="disabled"
                                (onValueChange)="enrollmentViewModel.MAILZIP = $event" maxlength="5">
                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
        <div class="row">
            <div class="col-16" id="txtEMERIND"
                [ngClass]="{'highlight-error':(linktoErrorControl.isEMERINDrror ===true) }">
                <ValidatedRadioButtonGroup
                    label="Would you like to provide an emergency contact for (name of beneficiary) account?"
                    [options]="emergencycontactOptions" [selectedValue]="enrollmentViewModel.EMERIND"
                    [radioGroupName]="'emergencycontactOptions'" (onValueChange)="ShowrEmergencyContactOptions($event)">
                </ValidatedRadioButtonGroup>
            </div>
        </div>
        <div class="row">
            <fieldset class="radio" *ngIf="IsEmergencyYes">
                <legend>Emergency Contact Info:</legend>
                <div class="row">
                    <div class="col-8" id="txtEMERNAME"
                        [ngClass]="{'highlight-error': (linktoErrorControl.isEMERNAMError ===true) }">
                        <div class="input-wrapper">
                            <ValidatedTextField label="Emergency contact:" [maxlength]="50"
                                [text]="enrollmentViewModel.EMERNAME"
                                [validators]="[LettersonlyAllowedFieldValidator,notBlankValidator]"
                                (onValueChange)="enrollmentViewModel.EMERNAME= $event">
                            </ValidatedTextField>
                        </div>
                    </div>
                    <div class="col-8" id="txtEMERPHONE"
                        [ngClass]="{'highlight-error': (linktoErrorControl.isEMERPHONError ===true) }">
                        <div class="input-wrapper">
                            <MaskedValidatedTextField class="field" [label]="'Phone Number:(numbers only)'"
                                id="emer-phone" [text]="enrollmentViewModel.EMERPHONE"
                                (onValueChange)="enrollmentViewModel.EMERPHONE = $event" [maxlength]="10"
                                [validators]="[phoneValidFieldValidator,notBlankValidator]"
                                [inputMask]="phoneNumberInputMask">
                            </MaskedValidatedTextField>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8" id="txtEMERREL"
                        [ngClass]="{'highlight-error':(linktoErrorControl.isEEMERRELError ===true) }">
                        <div class="input-wrapper">
                            <ValidatedTextField label="Relationship to You:" [maxlength]="50"
                                [text]="enrollmentViewModel.EMERREL"
                                [validators]="[lettersPeriodsApostrophesAndSpacesValidator]"
                                (onValueChange)="enrollmentViewModel.EMERREL= $event">
                            </ValidatedTextField>
                        </div>
                    </div>
                </div>

            </fieldset>
        </div>

        <div class="row">
            <div class="col-8" id="txtAPPEMAIL"
                [ngClass]="{'highlight-error': (linktoErrorControl.isAPPEMAILrror ===true) }">
                <div class="input-wrapper">
                    <ValidatedTextField class="" [maxlength]="40" [label]="'Email Address (optional):'"
                        id="EmailAddress" [text]="enrollmentViewModel.APPEMAIL" maxlength="100"
                        [validators]="[emailFieldValiator]"
                        (onValueChange)="enrollmentViewModel.APPEMAIL = $event">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <p>Please take out your red, white, and blue Medicare card to complete this section.</p>
                <br />
                <ul role="list">
                    <li role="listitem">
                        • Fill out this information as it appears on your Medicare card
                        <br />-OR-
                    </li>
                    <li role="listitem">• Attach a copy of your Medicare card or your letter from Social Security or the
                        Railroad Retirement Board.</li>
                </ul>

                <br>
            </div>
        </div>
        <div class="row">
            <div class="col-8" id="txtHICN" [ngClass]="{'highlight-error':(linktoErrorControl.isAHICNError ===true) }">
                <div class="input-wrapper">
                    <ValidatedTextField class="" [label]="'Medicare Number'" id="Medicare-Number" [maxlength]="12"
                        [text]="enrollmentViewModel.HICN" (onValueChange)="medicareNumberValueChange($event)"
                        (blur)="HICNBlur()" [validators]="[specialChracterNotAllowedFieldValidator]">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <div class="input-wrapper">
                    <JQDatePicker [selectedDate]="enrollmentViewModel.MEDA"
                        (elementClicked)="enrollmentViewModel.MEDA = $event" [label]="'Medicare Part A (Hospital) Effective Date (optional):'" id="MedA" for="MedA">
                    </JQDatePicker>
                    <div class="field__message">Format as MM/DD/YYYY</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <div class="input-wrapper">
                    <JQDatePicker [selectedDate]="enrollmentViewModel.MEDB"
                        (elementClicked)="enrollmentViewModel.MEDB = $event" [label]="'Medicare Part B (Medical) Effective Date (optional):'" id="MedB" for="MedB">
                    </JQDatePicker>
                    <div class="field__message">Format as MM/DD/YYYY</div>
                </div>
                <p>
                    You must have Medicare Part A or Part B (or both) to join a Medicare prescription drug plan.
                    <br />
                    <br />
                </p>
            </div>

        </div>
        <div class="row">
            <div class="col-16">
                <p>
                    <b>
                        Typically, you may enroll in a Medicare Prescription Drug Plan only during the annual enrollment
                        period between October 15 and December 7 of each year.
                    </b> Additionally, there are exceptions that
                    may allow you to enroll in a Medicare Prescription Drug Plan outside of the annual enrollment
                    period.
                    Please read the below statements carefully and check the box if the statement applies to you. By
                    checking any of the following boxes you are certifying that, to the best of your knowledge, you are
                    eligible for an Enrollment Period. If we later determine that this information is incorrect, you may
                    be
                    disenrolled.
                    <br />
                    <br />
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-16" id="txtreasonCode"
                [ngClass]="{'highlight-error':(linktoErrorControl.isreasonCodeError ===true) }">
                <ElectionPeriod [reasonCode]="reasonCode.toString()" [periodSelected]="periodSelected"
                    (periodSelectdChanged)="periodSelectdChanged($event)"
                    (reasonCodeChanged)="reasonCodeChanged($event)" (hasDateField)="hasDateField($event)"
                    (sepDateChange)="sepdatechange($event)" (AEPVisible)="AEPVisible($event)">
                </ElectionPeriod>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <p>
                    <br />
                    If none of these statements applies to you or you’re not sure, please contact us at 1-866-832-9775
                    to
                    see if you are eligible to enroll. We are open 24 hours a day, 7 days a week. TTY/TDD users call
                    711.
                    <br /> <br />
                </p>
            </div>
        </div>

        <div class="row">
            <div class="col-16">
                <p>
                    <b>
                        You can pay your monthly plan premium (including any late enrollment penalty you may owe) by
                        mail
                        each month. You can also choose to pay your premium by automatic deduction from your Social
                        Security
                        or Railroad Retirement Board benefit check each month.
                        If you are assessed a Part D-Income Related Monthly Adjustment Amount, you will be notified by
                        the
                        Social Security Administration. You will be responsible for paying this extra amount in addition
                        to
                        your plan premium. You will either have the amount withheld from your Social Security or
                        Railroad
                        Retirement Board benefit check or be billed directly by Medicare. Do NOT pay the Part D-IRMAA
                        extra
                        amount to Blue MedicareRx.
                    </b>
                    <br /><br />
                </p>
                <p>
                    People with limited incomes may qualify for Extra Help to pay for their prescription drug costs. If
                    you
                    qualify, Medicare could pay for 75% or more of your drug costs including monthly prescription drug
                    premiums, annual deductibles, and co-insurance. Additionally, those who qualify won’t have a
                    coverage
                    gap or a late enrollment penalty. Many people are eligible for these savings and don’t even know it.
                    For
                    more information about this Extra Help, contact your local Social Security office, or call Social
                    Security at 1-800-772-1213. TTY users should call 1-800-325-0778. You can also apply for Extra Help
                    online at <a (click)="socialSecurityLinkOnClick()" class="link"
                        href="http://www.socialsecurity.gov/prescriptionhelp"
                        target="_blank">www.socialsecurity.gov/prescriptionhelp</a>.

                </p>
                <br /> <br />
                <p>
                    If you qualify for Extra Help with your Medicare prescription drug coverage costs, Medicare will pay
                    all
                    or part of your plan premium. If Medicare pays only a portion of this premium, we will bill you for
                    the
                    amount that Medicare doesn’t cover.
                    <br /><br />
                </p>
                <p>
                    <b>Please select a premium payment option.</b> (If you don’t select an option, you will receive a
                    monthly bill.) Reminder, if you have secondary coverage that pays for part of your premiums (for
                    example: from your employer or an SPAP) then you must choose monthly bills that you can pay by mail
                    in
                    order for the secondary coverage to be applied correctly.
                </p>
                <br />
            </div>
        </div>



        <div class="row">
            <div class="col-16" id="txtPWO" [ngClass]="{'highlight-error':(linktoErrorControl.isPWOError ===true) }">
                <ValidatedRadioButtonGroup label="How would you like to pay for the monthly premium?"
                    labelClass="black-text" [options]="paymentOptions" [selectedValue]="enrollmentViewModel.PWO"
                    [radioGroupName]="'PaymentOptions'" (onValueChange)="paymentOptionChanged($event)">
                </ValidatedRadioButtonGroup>
            </div>
        </div>

        <div class="row" *ngIf="IsAutomatciSocial">
            <div class="col-16">
                <div class="bottom-20">
                    <p>
                        (Your monthly plan premium deduction may take up to 90 days to begin and will not cover any
                        premiums
                        for which we have already sent you an invoice. Therefore, until your automatic deduction is
                        approved, we will continue to send you a paper bill each month. Please continue to pay your
                        premium
                        invoice for as long as you receive it. In most cases, if Social Security/ Railroad Retirement
                        Board
                        accepts your request for automatic deduction, the first deduction from your Social
                        Security/Railroad
                        Retirement Board benefit might not include all premiums owed from your enrollment effective date
                        up
                        to the point withholding begins. If you owe any premiums retroactive to the date of the Social
                        Security/Railroad Retirement Board deductions, we will send you a paper bill for those premiums.
                        If
                        Social Security/Railroad Retirement Board does not approve your request for automatic
                        deductions, we
                        will send you a paper bill for your monthly premiums.) Note: the option to pay using a Credit
                        Card
                        will be included on your monthly invoice. You can also call us toll free once your enrollment in
                        the
                        plan is active, at 1-866-832-9775, 24 hours a day, 7 days a week. TTY/TDD users call 711.
                    </p>
                </div>
            </div>

        </div>
        <div class="row" *ngIf="IsAUTOMATIC_RAILROAD">
            <div class="col-16">
                <div class="bottom-20">
                    <p>
                        (Your monthly plan premium deduction may take up to 90 days to begin and will not cover any
                        premiums
                        for which we have already sent you an invoice. Therefore, until your automatic deduction is
                        approved, we will continue to send you a paper bill each month. Please continue to pay your
                        premium
                        invoice for as long as you receive it. In most cases, if Social Security/ Railroad Retirement
                        Board
                        accepts your request for automatic deduction, the first deduction from your Social
                        Security/Railroad
                        Retirement Board benefit might not include all premiums owed from your enrollment effective date
                        up
                        to the point withholding begins. If you owe any premiums retroactive to the date of the Social
                        Security/Railroad Retirement Board deductions, we will send you a paper bill for those premiums.
                        If
                        Social Security/Railroad Retirement Board does not approve your request for automatic
                        deductions, we
                        will send you a paper bill for your monthly premiums.) Note: the option to pay using a Credit
                        Card
                        will be included on your monthly invoice. You can also call us toll free once your enrollment in
                        the
                        plan is active, at 1-866-832-9775, 24 hours a day, 7 days a week. TTY/TDD users call 711.
                    </p>
                </div>
            </div>

        </div>

        <div *ngIf="IsElectronicFund">
            <div class="row">
                <div class="col-16">
                    <p>
                        Please send us a VOIDED check and fill in the requested information, which allows us to deduct
                        your
                        monthly premium payment from your bank account.<br />
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-8" id="txtACCHOLDERNAME"
                    [ngClass]="{'highlight-error':(linktoErrorControl.isACCHOLDERNAMEError ===true) }">
                    <div class="input-wrapper">
                        <ValidatedTextField class="field field--single"
                            [label]="'Name on Account (Alphanumeric Characters Only):'" id="name-on-account"
                            [text]="enrollmentViewModel.ACCHOLDERNAME"
                            (onValueChange)="enrollmentViewModel.ACCHOLDERNAME = $event" [validators]="[accountNameInvalidValidator]">
                        </ValidatedTextField>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-16" id="txtEFTTYPE"
                    [ngClass]="{'highlight-error':(linktoErrorControl.isEFTTYPEError ===true) }">
                    <ValidatedRadioButtonGroup label="Type of Account" id="account-type"
                        radioGroupName="account-type-radio-group" [options]="accountTypeOptions"
                        [selectedValue]="enrollmentViewModel.EFTTYPE"
                        (onValueChange)="enrollmentViewModel.EFTTYPE = $event" [validators]="[lettersSpaceshyphensAndApostrophesValidator]">
                    </ValidatedRadioButtonGroup>
                </div>
            </div>
            <fieldset>

                <legend>Bank Account:</legend>
                <div class="row">
                    <div class="col-8" id="txtFININSTNAME"
                        [ngClass]="{'highlight-error':(linktoErrorControl.isFININSTNAMEError ===true) }">
                        <div class="input-wrapper">
                            <ValidatedTextField class="field field--single"
                                [label]="'Financial Institution (Alphanumeric Characters Only):'"
                                id="financial-institution" [text]="enrollmentViewModel.FININSTNAME"
                                (onValueChange)="enrollmentViewModel.FININSTNAME = $event" [validators]="[lettersSpaceshyphensAndApostrophesValidator]">
                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8" id="txtROUTINGNB"
                        [ngClass]="{'highlight-error':(linktoErrorControl.isROUTINGNBError ===true) }">
                        <div class="input-wrapper">
                            <ValidatedTextField class="field field--single" [label]="'Routing Number'"
                                id="routing-number" [text]="enrollmentViewModel.ROUTINGNB"
                                (onValueChange)="enrollmentViewModel.ROUTINGNB = $event" [maxlength]="9"
                                [validators]="[onlyDigitsValidator]">
                            </ValidatedTextField>
                        </div>
                    </div>
                    <div class="col-8" id="txtACCOUNTNB"
                        [ngClass]="{'highlight-error': (linktoErrorControl.isACCOUNTNBError ===true) }">
                        <div class="input-wrapper">
                            <ValidatedTextField class="field field--single" [label]="'Account Number'"
                                id="account-number" [text]="enrollmentViewModel.ACCOUNTNB" [maxlength]="15"
                                (onValueChange)="enrollmentViewModel.ACCOUNTNB = $event" [validators]="[accountNumberInvalidValidator]">
                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
            </fieldset>
            <div class="row">
                <div class="col-16">
                    <p class="bottom-20">
                        <i>
                            By selecting Automatic Bank Withdrawal, I authorize the bank or financial
                            organization named above to pay my premium through electronic bank withdrawal payable to
                            Blue
                            MedicareRx. I authorize the deduction of up to $300 at a time (only if the balance is such).
                            The
                            bank or other financial organization will be fully protected in honoring these payments
                            until
                            notice from me canceling this request is received.
                        </i>
                    </p>
                </div>
            </div>
        </div>
        <!--NEJE DES Decommision Start-->
        <!--<div *ngIf="PaperlessOption">
                <div class="row">
                    <div class="col-16">
                        <p><strong>Paperless Settings</strong></p>
                    </div>
                    <div class="col-16">-->
        <!--<p><strong>Get the benefit of paperless documents</strong></p>-->
        <!--<p>
                        Once your application is complete, would you like to receive Medicare Part D documents electronically? This lets you keep your documents organized in one secure online location that’s always accessible.
                    </p>

                    <div class="row">
                        <br />
                    </div>
                    <p>
                        The types of documents include evidence of coverage, your formulary, a pharmacy directory, explanation of benefit statements, plan coverage information, billing information and general plan information and messaging. You can go back to mailed versions at any time.
                    </p>

                </div>

            </div>
            <div class="row">
                <div class="col-16">
                    <div class="bottom-20">-->
        <!--<p><strong>Do you want paperless documents?</strong></p>-->
        <!--</div>
                        <div class="bottom-20">
                            <ValidatedCheckbox [id]="'eobOptions'"
                                               [label]="eobOptionLabel"
                                               [checked]="enrollmentViewModel.EOB==='3'"
                                               (onValueChange)="eobOptionChanged($event)">
                            </ValidatedCheckbox>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <p>
                            Once you enroll, or if you are already a returning member, you can go back to mailed versions at any time on <a class="link" href="https://www.caremark.com" target="_blank">Caremark.com</a>.
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="bottom-20">
                            <label>{{emailLabel}}</label>
                            <ValidatedTextField class="" [maxlength]="40"
                                                [label]="''"
                                                id="EmailAddress"
                                                [text]="enrollmentViewModel.APPEMAIL"
                                                (onValueChange)="enrollmentViewModel.APPEMAIL = $event">

                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
            </div>-->
        <!--NEJE DES Decommision End-->
        <div class="row">
            <div class="col-16">
                <p>
                    Some individuals may have other drug coverage, including other private insurance, TRICARE, Federal
                    employee health benefits coverage, VA benefits, or State pharmaceutical assistance programs.
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-16" id="txtOTHCVRG"
                [ngClass]="{'highlight-error': (linktoErrorControl.istOTHCVRGError ===true) }">
                <ValidatedRadioButtonGroup
                    label="1. Will you have other prescription drug coverage in addition to Blue MedicareRx?"
                    labelClass="black-text" [options]="rblSecondaryCoverage" [radioGroupName]="'rblSecondaryCoverage'"
                    [selectedValue]="enrollmentViewModel.OTHCVRG" (onValueChange)="ShowCoverageInfo($event)">
                </ValidatedRadioButtonGroup>
            </div>
        </div>

        <div *ngIf="IsCovergInfoYes">
            <div class="row">
                <div class="col-16">
                    <p>
                        If “yes”, please list your other coverage and your identification (ID) number(s) for this
                        coverage:
                    </p>
                </div>
            </div>
            <fieldset>
                <legend>Other Coverage:</legend>
                <div class="row">
                    <div class="col-8" id="txtOTHCVRGNAME"
                        [ngClass]="{'highlight-error': (linktoErrorControl.isOTHCVRGNAMError ===true) }">
                        <div class="input-wrapper">
                            <ValidatedTextField [label]="'Name of other coverage'"
                                [text]="enrollmentViewModel.OTHCVRGNAME" [validators]="[lettersSpaceshyphensAndApostrophesValidator]"
                                (onValueChange)="enrollmentViewModel.OTHCVRGNAME = $event">
                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8" id="txtOTHCVRGID"
                        [ngClass]="{'highlight-error': (linktoErrorControl.isOTHCVRGIDrror ===true) }">
                        <div class="input-wrapper">
                            <ValidatedTextField [label]="'ID# for this coverage (optional)'"
                                [text]="enrollmentViewModel.OTHCVRGID"
                                [validators]="[lettersNumbersAndspacesValidator]"
                                (onValueChange)="enrollmentViewModel.OTHCVRGID = $event">

                            </ValidatedTextField>
                        </div>

                    </div>

                </div>

                <div class="row">

                    <div class="col-8" id="txtOTHCVRGGRP"
                        [ngClass]="{'highlight-error': (linktoErrorControl.isOTHCVRGGRPError ===true) }">
                        <div class="input-wrapper">
                            <ValidatedTextField [label]="'Group # for this coverage (optional)'"
                                [text]="enrollmentViewModel.OTHCVRGGRP"
                                [validators]="[lettersNumbersAndspacesValidator]"
                                (onValueChange)="enrollmentViewModel.OTHCVRGGRP = $event">
                               
                            </ValidatedTextField>
                        </div>

                    </div>

                </div>
            </fieldset>
        </div>
        <div class="row">
            <div class="col-16" id="txtRBLLONGTERM" style="margin-top: 6px;"
                [ngClass]="{'highlight-error': (linktoErrorControl.isRBLLONGTERMError ===true) }">
                <ValidatedRadioButtonGroup
                    label="2.Are you a resident in a long-term care facility, such as a nursing home?"
                    labelClass="black-text" [options]="rbllongTerm" [selectedValue]="enrollmentViewModel.RBLLONGTERM"
                    [radioGroupName]="'rbllongTerm'" (onValueChange)="ShowrbllongtermOptions($event)">
                </ValidatedRadioButtonGroup>
            </div>
        </div>
        <div class="row">
            <fieldset class="radio" *ngIf="IsRbllongtermYes">
                <legend>Long term care facility:</legend>
                <div class="row">
                    <div class="col-16">
                        <p>
                            If “yes” please provide the following information:
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper">
                            <ValidatedTextField label="Name of Facility:" [maxlength]="50"
                                [text]="enrollmentViewModel.LTCFACILITY"
                                [validators]="[lettersPeriodsApostrophesSpacesAndHyphensValidator]"
                                (onValueChange)="enrollmentViewModel.LTCFACILITY= $event">
                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper">
                            <ValidatedTextField label="Address of Facility (optional):" [maxlength]="150"
                                [text]="enrollmentViewModel.LTCADD1"
                                [validators]="[lettersPeriodsApostrophesSpacesAndHyphensValidator]"
                                (onValueChange)="enrollmentViewModel.LTCADD1= $event">
                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper">
                            <MaskedValidatedTextField class="field" [label]="'Phone Number of Facility:(numbers only)'"
                                id="ltc-phone" [text]="enrollmentViewModel.LTCPHONE"
                                (onValueChange)="enrollmentViewModel.LTCPHONE = $event" [maxlength]="10"
                                [validators]="[phoneValidFieldValidator]"
                                [inputMask]="phoneNumberInputMask">
                            </MaskedValidatedTextField>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
        <div class="row">
            <div class="col-16" style="margin-bottom: 20px;">
                <div class="input-wrapper">
                    <ng-container *ngIf="Showfor2023">
                        <legend class="black-text">
                            Please check the box below if you would prefer that we send you
                            information in another format:
                        </legend>
                        <ValidatedCheckbox class="centered-checkbox" [id]="'large-print'" [label]="'Large Print'"
                            [checked]="langFormat" (onValueChange)="onLangFormatchange($event)">
                        </ValidatedCheckbox>
                    </ng-container>

                    <ng-container *ngIf="!Showfor2023">
                        <ValidatedRadioButtonGroup label="Please select an option below if you would prefer that we send you
                    information in another format (Optional):" labelClass="black-text" [options]="rblAccessibility"
                            [selectedValue]="enrollmentViewModel.EOB" (onValueChange)="enrollmentViewModel.EOB= $event"
                            [radioGroupName]="'rblLangformat'">
                        </ValidatedRadioButtonGroup>
                    </ng-container>
                </div>
            </div>
        </div>
        <br />

        <div class="row" *ngIf="!Script2020">
            <div class="col-16">
                <div class="input-wrapper">
                    <ValidatedRadioButtonGroup label="Do you work? (Optional)" labelClass="black-text"
                        [options]="rblEnroleeWorkStatus" [selectedValue]="enrollmentViewModel.ENROLLEEWORKSTATUS"
                        (onValueChange)="enrollmentViewModel.ENROLLEEWORKSTATUS = $event"
                        [radioGroupName]="'rblEnrolleeWork'">
                    </ValidatedRadioButtonGroup>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="!Script2020">
            <div class="col-16">
                <div class="input-wrapper">
                    <ValidatedRadioButtonGroup label="Does your spouse work? (Optional)" labelClass="black-text"
                        [options]="rblSpouceWorkStatus" [selectedValue]="enrollmentViewModel.SPOUSEWORKSTATUS"
                        (onValueChange)="enrollmentViewModel.SPOUSEWORKSTATUS = $event"
                        [radioGroupName]="'rblSpouceWork'">
                    </ValidatedRadioButtonGroup>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="!visibleFrom2026">
            <raceethnicity [enrollmentRaceEthnicityViewModel]="enrollmentViewModel"></raceethnicity>
        </div>

        <div class="row" *ngIf="visibleFrom2025">
            <div class="col-22">
                <genderPref [enrollmentgenderPrefyViewModel]="enrollmentViewModel"></genderPref>
            </div>
        </div>

        <div class="row">
            <div class="col-16">
                <p>
                    Please contact Blue MedicareRx at 1-866-832-9775 if you need information in a format other than what
                    is
                    listed above. TTY/TDD users should call 711. Our office hours are 24 hours a day, 7 days a week
                    <br />
                </p>
                <p>
                    <b> Please read:</b> <br />
                    If you are a member of a Medicare Advantage Plan (like an HMO or PPO), you may already have
                    prescription
                    drug coverage from your Medicare Advantage Plan that will meet your needs. By joining Blue
                    MedicareRx,
                    your membership in your Medicare Advantage Plan may end. This will affect both your doctor and
                    hospital
                    coverage as well as your prescription drug coverage. Read the information that your Medicare
                    Advantage
                    Plan sends you and if you have questions, contact your Medicare Advantage Plan.
                    <br />

                </p>
                <p>
                    If you currently have health coverage from an employer or union, joining Blue MedicareRx could
                    affect
                    your employer or union health benefits. You could lose your employer or union health coverage if you
                    join Blue MedicareRx. Read the communications your employer or union sends you. If you have
                    questions,
                    visit their website, or contact the office listed in their communications. If there isn't
                    information on
                    whom to contact, your benefits administrator or the office that answers questions about your
                    coverage
                    can help.
                    <br />
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <label for="notes">Notes (max 300 characters)(optional)</label>
                <textarea rows="3" cols="60" name="txtNotes" [(ngModel)]="enrollmentViewModel.NOTES"
                    maxlength="300" id="notes"></textarea>
            </div>

        </div>

        <div class="row">
            <div class="col-24">
                <button class="button cancel" (click)="onBack()">Go Back and Make Changes</button>
            </div>
        </div>
        <div class="row" *ngIf="!isIndv">
            <div class="col-24">
                <button class="button primary" (click)="incompleteClick()">Continue As Incomplete</button>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <button class="button primary" (click)="formSubmit()">Continue</button>
            </div>
        </div>
    </div>
    <style>
        fieldset {
            border: 4px solid #ccc;
            padding: 1rem;
            margin-top: 1rem;
            border-radius: 5px;
            margin-bottom: 1rem;
        }

        legend {
            font-size: 1.1rem;
            font-weight: bold;
        }

        button:hover,
        button:focus {
            background-color: #0074CC !important;
            border: 2px solid #0074CC !important;
            border-bottom: 2px solid #1b75bc !important;
            outline: 3px solid #1b75bc !important;
            outline-offset: 2px !important;
            color: #fff !important;
            /* Lighter blue *
            /* Optional: remove default outline */
        }
    </style>